<template>
    <div>
<MobileNavigation></MobileNavigation>
<br>
        <div class=" header text-center">

            <div class="material pt-4">
                <div class="profile">
                    <div class="cover">
                        <div class="photo">
                            <img
                                src=""
                                alt="" width="100" class="bg-red-500">
                        </div>
                        <div class="info ">
                            <div><h3 class="text-white text-left">User</h3></div>
                            <div><p class="text-white text-left lead">Assigned to: User</p></div>
                        </div>
                        <div class="edit-image">
                            <img
                                src="images/ic_pencil_left.png"
                                class="img-fluid"
                                style="width: 20px; height: 20px" /></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="list-services" >
            <ul class="services-list list-unstyled" >
                <li>
                    <a href="#" class="services-link" >
                        <div class="link-box"><i class="fab fa-whatsapp text-xl"></i></div>
                        Whatsapp
                    </a>
                </li>

                <li>
                    <a href="#" class="services-link">
                        <div class="link-box"><i class="fab fa-telegram"></i></div>
                        Telegram
                    </a>
                </li>
                <li style="border-right: 10px solid #ffffff;">
                    <a href="#" class="services-link" >
                        <div class="link-box" ><i class="fas fa-phone-alt text-xl"></i></div>
                        Call
                    </a>
                </li>
                <li>
                    <a href="#" class="services-link">
                        <div class="link-box"><i class="fas fa-sms text-xl"></i></div>
                        SMS
                    </a>
                </li>
                <li>
                    <a href="#" class="services-link">
                        <div class="link-box"><i class="fas fa-at"></i></div>
                        Email
                    </a>
                </li>
                <li style="border-right: 10px solid #ffffff;">
                    <a href="#" class="services-link" >
                        <div class="link-box" ><i class="fas fa-map-marker-alt text-xl"></i></div>
                        Check-in
                    </a>
                </li>
            </ul>
        </div>

        <div class="sticky bg-white">
            <div class="d-flex justify-content-center mt-4">
                <div id="" class="justify-content-center">
                    <ul class="nav justify-content-center">
                        <li class="nav-item rounded-xl mr-2" id="detailsList" v-on:click="showDetail">
                            <a class="nav-link no-decoration"   style="border-right: 2px solid #ffffff;">Details</a>
                        </li>
                        <li class="nav-item rounded-xl ml-2 mr-2" id="activityList" v-on:click="showActivity">
                            <a class="nav-link no-decoration"  >Activity</a>
                        </li>
                        <li class="nav-item rounded-xl ml-2" id="relatedList" v-on:click="showRelated">
                            <a class="nav-link no-decoration" style="border-left: 2px solid #ffffff;">Related</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="content">
          <div id="detailsContainer">
            <h3 class="text-xl">Details</h3>
                        DetailsDetailsDetailsDetailsDetails
          </div>
          <div id="activityContainer">
            <h3 class="text-xl">Activity</h3>
            ActivityActivityActivityActivityActivity
          </div>
          <div id="relatedContainer">
            <h3 class="text-xl">Related</h3>
                        RelatedRelatedRelatedRelatedRelated
          </div>
        </div>
            
    </div>

</template>

<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .no-decoration{
      text-decoration: none;
      color: black;
    }

    .no-decoration:focus{
      text-decoration: none;
      color: black;

    }

    .no-decoration:hover{
      text-decoration: none;
      color: black;
    }


/* Screen */


    div.sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 58px;
        background-color: transparent;
    }


    #de-act-re-navbar {
        overflow: hidden;
        background-color: #EBEFF3;
        border-radius: 200px;
    }

    #de_act_re_navbar a {
        float: left;
        display: block;
        color: #333333;
        text-align: center;
        text-decoration: none;
        font-size: 17px;
    }

    #de_act_re_navbar a:hover {
        background-color: #FFB455;
        color: #ffffff;
    }

    .content {
        padding: 16px;
    }

    .sticky {
        position: fixed;
        top: 60px;
    }

    .sticky + .content {
        padding-top: 60px;
    }

    /*Header STARTS*/
    .material {
        width: 100%;
        position: relative;
        background: #1e1d23;
    }

    .material .profile .cover {
        width: 100%;
        height: 160px;
        margin-top: 10px;
        overflow: hidden;
        position: relative;
        background: #234c6d;
    }

    .material .profile .photo {
        left: 30px;
        z-index: 7;
        bottom: 30px;
        overflow: hidden;
        border-radius: 50%;
        position: absolute;
    }

    .material .profile .photo img {
        width: 100%;
        display: block;
    }

    .material .profile .info {
        left: 150px;
        bottom: 45px;
        position: absolute;
    }

    .edit-image {
        left: 90%;
        top: 10%;
        position: absolute;
    }

    /*Header ENDS*/

    /*Tic-Tac-Toe Grid STARTS*/

    .list-services {
        padding: 10px 20px;
        text-align: center;
        position: relative;
    }

    .list-services .img-holder {
        border-radius: 50%;
        overflow: hidden;
        border: 2px solid #fff;
        margin: -50px auto 0;
        max-width: 75px;
    }

    .services-list {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        text-align: center;
        position: relative;
        margin: 0;
    }

    .services-list:before {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: -webkit-linear-gradient(left, #fff 0%, rgba(255, 255, 255, 0) 50%, #fff 100%);
        background-image: linear-gradient(to right, #fff 0%, rgba(255, 255, 255, 0) 50%, #fff 100%);
        z-index: 1;
    }

    .services-list:after {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: -webkit-linear-gradient(bottom, #fff 0%, rgba(255, 255, 255, 0) 50%, #fff 100%);
        background-image: linear-gradient(to top, #fff 0%, rgba(255, 255, 255, 0) 50%, #fff 100%);
        z-index: 1;
    }

    .services-list li {
        width: 33.333%;
        position: relative;
        background-color: #fff;
        height: 90px;
        padding: 12px 0;
    }

    .services-list li:before {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border-right: 1px solid #00b588;
        border-bottom: 1px solid #00b588;
    }

    .services-list .link-box {
        margin-bottom: 7px;
        height: 40px;
    }

    .services-list a {
        display: block;
        position: relative;
        z-index: 2;
        color: #24505f;
        font-size: .8571rem;
        line-height: 1px;
    }

    .services-list a:hover {
        color: #00b588;
    }

    .services-list a:hover i {
        color: #24505f;
    }

    .services-list a i {
        -webkit-transition: color .2s ease-in-out;
        transition: color .2s ease-in-out;
        color: #00b588;
        font-size: 2.428571rem;
    }

    .services-list a i.icon-money,
    .services-list a i.icon-smartphone,
    .services-list a i.icon-schedule,
    .services-list a i.icon-smartphone1 {
        font-size: 2.857142rem;
    }

    .services-list a i.icon-calc,
    .services-list a i.icon-marker {
        font-size: 2.714285rem;
    }

    .services-link {
        text-decoration: none;
    }

    .services-link:active {
        text-decoration: none;
        color: #42E2C3;
    }

    .services-link:focus {
        text-decoration: none;
        color: #42E2C3;
    }

    .tab-selected{
      background-color:#42E2C3;
    }
/* Screen - END */

    </style>

<script>
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'

 var $ = require('jquery');

export default {
  props: ["sessions"],

  components: {
    MobileNavigation,
    Welcome,
    PageTitle,
    JetNavLink,
  },
  data() {
    return {
      title: "Attendance Menu",
      username: null,
      password: null,

    };
  },
  methods: {
    getActivityList(){

    },
    getRelatedList(){

    },
    getDetailList(){

    },
      showMenu: function () {
                $('.menu-button-link').show();
                $('.back-button-link').hide();
            },

            showActivity(){
              this.getActivityList();
              document.getElementById('detailsList').classList.remove("tab-selected");
              document.getElementById('activityList').classList.add("tab-selected");
              document.getElementById('relatedList').classList.remove("tab-selected");
              
              document.getElementById('activityContainer').style.display = "block";
              document.getElementById('detailsContainer').style.display = "none";
              document.getElementById('relatedContainer').style.display = "none";

              
            },
            showDetail(){
              this.getDetailList();
              document.getElementById('detailsList').classList.add("tab-selected");
              document.getElementById('activityList').classList.remove("tab-selected");
              document.getElementById('relatedList').classList.remove("tab-selected");
              

              document.getElementById('activityContainer').style.display = "none";
              document.getElementById('detailsContainer').style.display = "block";
              document.getElementById('relatedContainer').style.display = "none";
            },
            showRelated(){
              this.getRelatedList();
              document.getElementById('relatedList').classList.add("tab-selected");
              document.getElementById('activityList').classList.remove("tab-selected");
              document.getElementById('detailsList').classList.remove("tab-selected");
              
              document.getElementById('activityContainer').style.display = "none";
              document.getElementById('detailsContainer').style.display = "none";
              document.getElementById('relatedContainer').style.display = "block";
            }

  },
  mounted() {
     this.showMenu();
     this.showDetail();
  },
};
</script>
